<script setup lang="ts">
import {
  PhxsgTextProps as PhxsgCoreTextProps,
  PhxsgText as PhxsgCoreText,
} from '@sg-core/src/View/Components/Atoms/Text';

import './text.css';

export type IwcTextVariant = 'display' | 'headline' | 'body' | 'label';
export type IwcTextSize = 'small' | 'medium' | 'large';
export type IwcTextColor = 'primary' | 'secondary' | 'tertiary';

export type PhxsgTextProps = Omit<PhxsgCoreTextProps, 'variant' | 'size'> & {
  variant?: IwcTextVariant;
  size?: IwcTextSize;
  color?: IwcTextColor;
};

withDefaults(defineProps<PhxsgTextProps>(), {
  variant: 'body',
  size: 'medium',
  color: 'primary',
});
</script>

<template>
  <PhxsgCoreText
    v-bind="$props"
    :class="{
      [`phxsg-text--${color}`]: color,
    }"
  >
    <slot />
  </PhxsgCoreText>
</template>
